import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Resizer = styled.div`
  position: absolute;
  right: calc(-1 * ${spacing('md')});
  bottom: calc(-1 * ${spacing('md')});
  cursor: se-resize;
  margin: ${spacing(1.5)};

  transition: all ease-in-out 100ms;
  border-bottom: dashed 6px ${({ theme }) => theme.colors.primary};
  border-right: dashed 6px ${({ theme }) => theme.colors.primary};

  &:hover {
    border-bottom: solid 7px ${({ theme }) => theme.colors.primary};
    border-right: solid 7px ${({ theme }) => theme.colors.primary};
  }
`;
